export default __webpack_public_path__ + "static/banner-why-you-should-get-a-low-rate-credit-card-0f18a76217d370af5ac734b5834cea53.jpg";